module.exports = __webpack_public_path__ + "static/media/emoji.a014e636.jpg";